import getDeviceType from '../../util/deviceType';

// Shared builder for the provider-level parameters attached to a CTA/TFN anchor.
//
// cta_click_out (cta-events.js) and provider_impression (provider-impressions.js)
// must report the SAME event parameters (HOME-9598), so both read them from here.
// Keeping one source of truth prevents the two events from drifting apart.

// UA doesn't change during the page, so resolve the device bucket once (HOME-9865).
const DEVICE_TYPE = getDeviceType();

// Product category falls back to the page-level #productcategory field, mirroring
// the original cta-events.js behaviour. Read at call time — the field is static.
function pageProductCategory() {
    const field = document.getElementById('productcategory');
    return field ? field.value : 'General';
}

// innerText when present; 'image' for image-only anchors; '' otherwise.
function linkText(element) {
    if (element.innerText !== '') {
        return element.innerText;
    }
    if (element.innerHTML.includes('img')) {
        return 'image';
    }
    return '';
}

// GTM Data Layer Variables are "last value wins" and persist across pushes, so
// every producer of these params must clear them once its tag has read them --
// otherwise a later unrelated event (site_search, an internal link click)
// inherits the last provider's values (HOME-9595). Shared here so cta_click_out
// and provider_impression can never drift on what they clean up.
//
// productCategory is restored to the page-level default rather than cleared,
// since GA4 sends it on every event via the config tag. deviceType is page-global
// and deliberately left in place.
export function providerParamsReset() {
    return {
        serviceProvider: undefined,
        partner: undefined,
        productCategory: pageProductCategory(),
        activePromotion: undefined,
        elementPlacement: undefined,
        position: undefined,
        providerCID: undefined,
        destinationType: undefined,
        href: undefined,
        linkText: undefined,
        elementClicked: undefined,
    };
}

// The parameter set shared by cta_click_out and provider_impression. `element` is
// the CTA/TFN anchor ([data-ga="referral-cta"] / [data-ga="referral-call"]).
export default function buildProviderParams(element) {
    return {
        href: element.href || null,
        serviceProvider: element.dataset.productname || null,
        // Partner (provider) the product is sold through, from the `partner`
        // taxonomy via get_cta_data_attributes(). Products with no partner —
        // VPNs, insurance, discontinued brands — report null.
        partner: element.dataset.partner || null,
        productCategory: element.dataset.productcategory || pageProductCategory(),
        activePromotion: element.dataset.sale || 'false',
        elementPlacement: element.dataset.elementplacement || null,
        position: element.dataset.order || 'single',
        linkText: linkText(element),
        providerCID: element.dataset.providercid || '0',
        deviceType: DEVICE_TYPE,
    };
}
